import type { LoadState } from "../types";

interface StatusBlockProps<T> {
  state: LoadState<T>;
  loadingLabel?: string;
}

export function StatusBlock<T>({ state, loadingLabel = "Loading…" }: StatusBlockProps<T>) {
  if (state.status === "loading") {
    return (
      <div className="status" role="status" aria-live="polite">
        {loadingLabel}
      </div>
    );
  }
  if (state.status === "error") {
    return (
      <div className="status error" role="alert">
        {state.message}
      </div>
    );
  }
  if (state.status === "not_found") {
    return (
      <div className="status not-found" role="status">
        {state.message}
      </div>
    );
  }
  if (state.status === "empty") {
    return (
      <div className="status empty" role="status">
        {state.message}
      </div>
    );
  }
  return null;
}

export function formatDistance(value: number, units?: string): string {
  const rounded = Number.isInteger(value) ? String(value) : value.toFixed(1);
  return units ? `${rounded} ${units}` : rounded;
}

export function companyLabel(name?: string | null): string {
  return name?.trim() || "No exhibitor linked";
}
